import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div>
      <section class="home-service"  style={{overflowX:"hidden"}}>
        <div class="container-fluid flex-column d-flex align-items-center">
          <div class="section-head text-center">
            <div class="row" data-aos="fade-up">
              <div class="col-lg-8 offset-lg-2">
                <div class="title-divider"></div>
                <h2 class="section-title" >
                  Explore Our Best <span class="primary-color">Services</span>
                </h2>
                <p>
                  Delivering innovative technology solutions to help your business grow and succeed.
                </p>
              </div>
            </div>
          </div>

          <div class="service-inner " style={{ width: '90%' }}>
            <div class="row g-0 align-items-center">
              {/* <!-- Left Services --> */}
              <div class="col-sm-12 col-md-5 col-lg-4 text-right" >
                <div class="service-icon-box" data-aos="fade-right" data-aos-delay="200">
                  <div class="service-icon-content">
                    <h4><a href="/Web-develop">Web Development</a></h4>
                    <p>Responsive and scalable websites built  modern tech.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-Consultancy"></i>
                  </div>
                </div>

                <div class="service-icon-box" data-aos="fade-right" data-aos-delay="300">
                  <div class="service-icon-content">
                    <h4><a href="/mobile-app">App Development</a></h4>
                    <p>Custom mobile apps for iOS and Android platforms.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-Target"></i>
                  </div>
                </div>

                <div class="service-icon-box" data-aos="fade-right" data-aos-delay="300">
                  <div class="service-icon-content">
                    <h4><a href="/ui-ux">UI & UX design</a></h4>
                    <p>Intuitive designs that improve user experience and flow.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-speed"></i>
                  </div>
                </div>
              </div>

              {/* <!-- Center Image --> */}
              <div class="col-sm-6 offset-sm-3 offset-md-0 col-md-2 col-lg-4 text-center">
                <figure class="service-image">
                  <img src="assets/images/img1.jpg" alt="Our Services" />
                </figure>
              </div>

              {/* <!-- Right Services --> */}
              <div class="col-sm-12 col-md-5 col-lg-4 text-left">
                <div class="service-icon-box" data-aos="fade-left" data-aos-delay="200">
                  <div class="service-icon-content">
                    <h4><a href="/cloud">Cloud Services</a></h4>
                    <p>Secure and scalable cloud solutions for every business.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-graph-2"></i>
                  </div>
                </div>

                <div class="service-icon-box" data-aos="fade-left" data-aos-delay="300">
                  <div class="service-icon-content">
                    <h4><a href="/aiml">AI & ML Solutions</a></h4>
                    <p>Smart insights and automation powered by AI & ML.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-idea"></i>
                  </div>
                </div>

                <div class="service-icon-box" data-aos="fade-left" data-aos-delay="300">
                  <div class="service-icon-content">
                    <h4><a href="/digital">Digital Marketing</a></h4>
                    <p>Boost visibility and drive results with SEO & campaigns.</p>
                  </div>
                  <div class="service-icon">
                    <i aria-hidden="true" class="icon icon-Mechanic"></i>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Services
